import TopMenu from "../UI/TopMenu";

const TOPICS = [
  "For You",
  "Trending",
];

interface IProps {
  tab: string;
  onChange: (code: string) => void;
}

export const HomeTabSelector = (props: IProps) => {
  return (
    <TopMenu
      topicValues={TOPICS}
      currentTopic={props.tab}
      setCurrentTopic={props.onChange}
    />
  );
};
